export const APPEND_RESIZE_EVENT = 'APPEND_RESIZE_EVENT'
export const REMOVE_RESIZE_EVENT = 'REMOVE_RESIZE_EVENT'

const common = {
  namespaced: true,
  state: {
    resizeEventSet: new Set(), // 时间
    scale: 1, // 页面缩放比例
  },
  getters: {
    isProduction: () => process.env.NODE_ENV === 'production',
    resizeEventSet: state => state.resizeEventSet,
    scale: state => state.scale,
  },
  mutations: {
    [APPEND_RESIZE_EVENT](state, o) {
      state.resizeEventSet.add(o)
    },
    [REMOVE_RESIZE_EVENT](state, o) {
      if (state.resizeEventSet.has(o)) state.resizeEventSet.delete(o)
    },
    SET_SCALE(state, o) {
      state.scale = o
    },
  },
  actions: {
  },
}

export default common
